<template>
    <div>
        <div v-if="actionActive">
            <component
                v-if="prepareActionComponent !== null"
                :is="prepareActionComponent"
                :participants="participants"
                @close="close"
                @sendAction="sendAction"
            />
        </div>
        <div>
            <div class="modal" :class="{ 'is-active': !actionActive }">
                <div class="modal-background"></div>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">
                            {{ $t("send-action.title") }}
                        </p>
                    </header>
                    <section class="modal-card-body">
                        <div class="has-text-centered">
                            <div v-if="sendingAction">
                                <Loading />
                                <p>{{ $t("send-action.sending") }}</p>
                            </div>
                            <div v-else>
                                <Icon
                                    v-if="correct"
                                    family="fa"
                                    name="fa-check fa-2x"
                                />
                                <Icon
                                    v-if="!correct"
                                    family="fa"
                                    name="fa-times fa-2x"
                                />
                                <div>
                                    <p>{{ message }}</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" @click="closeModal">
                            {{ $t("send-action.close") }}
                        </button>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PrepareText from "./text/PrepareText";
import PrepareFile from "./file/PrepareFile";
import PreparePhoto from "./photo/PreparePhoto";
import PrepareDate from "./date/PrepareDate";
import PrepareShareDocument from "./shared-document/PrepareShareDocument";
import PrepareSign from "./sign/PrepareSign.vue";
import GetSurvey from "./get-survey/PrepareGetSurvey";

import Loading from "@/components/Loading";
import { mapGetters } from "vuex";

export default {
    name: "base-prepare-action",
    components: {
        Loading,
    },
    props: {
        signalRSocket: { type: Object, required: true },
        actualAction: { type: String, default: null },
        roomId: { type: String, required: true },
        participants: { type: Array },
    },
    data() {
        return {
            prepareActionComponent: null,
            sendingAction: false,
            actionActive: true,

            correct: true,
            message: "",
        };
    },
    mounted() {
        if (this.actualAction !== null) {
            this.loadAction(this.actualAction);
        }

        this.signalRSocket.on("ActionSended", this.signalRActionSended);
    },
    watch: {
        actualAction(actualAction) {
            this.loadAction(actualAction);
        },
    },
    computed: {
        ...mapGetters("oidcStore", ["oidcUser"]),
        userId() {
            let user = this.oidcUser;
            if (user === undefined || user === null) {
                return "";
            }
            return user.sub;
        },
    },
    methods: {
        signalRActionSended(response) {
            window.console.log("signalRActionSended");
            if (response.correct) {
                this.message = this.$t("send-action.correct");
            } else {
                this.message = this.$t("send-action.not-correct");
                window.console.log(response.message);
            }
            this.correct = response.correct;
            this.sendingAction = false;
        },
        closeModal() {
            // If is correct close both modals
            if (this.correct) {
                this.close();
            }
            this.actionActive = true;
        },
        close() {
            this.$emit("close");
        },
        sendAction(action) {
            switch (action.type) {
                case "text":
                    this.sendTextAction(action);
                    break;
                case "file":
                    this.sendFileAction(action);
                    break;
                case "photo":
                    this.sendPhotoAction(action);
                    break;
                case "date":
                    this.sendDateAction(action);
                    break;
                case "share-document":
                    this.sendShareDocument(action);
                    break;
                case "sign":
                    this.sendSignAction(action);
                    break;
                case "get-survey":
                    this.sendGetSurveyAction(action);
                    break;
            }
            this.sendingAction = true;
            this.actionActive = false;
        },
        sendTextAction(action) {
            this.signalRSocket.invoke(
                "SendTextAction",
                this.roomId,
                this.userId,
                action.user.id,
                action.title
            );
        },
        sendDateAction(action) {
            this.signalRSocket.invoke(
                "SendDateAction",
                this.roomId,
                this.userId,
                action.user.id,
                action.title,
                action.minDate,
                action.maxDate
            );
        },
        sendFileAction(action) {
            this.signalRSocket.invoke(
                "SendFileAction",
                this.roomId,
                this.userId,
                action.user.id,
                action.title
            );
        },
        sendPhotoAction(action) {
            this.signalRSocket.invoke(
                "SendPhotoAction",
                this.roomId,
                action.user.id,
                action.id,
                action.title,
                action.answer.photoId,
                action.answer.fileName
            );
        },
        sendShareDocument(action) {
            this.signalRSocket.invoke(
                "SendShareDocument",
                this.roomId,
                action.id,
                action.title,
                action.answer.fileId
            );
        },
        sendSignAction(action) {
            this.signalRSocket.invoke(
                "RequireSign",
                this.roomId,
                action.user.id,
                action.fileId,
                action.addSignerName
            );
        },
        sendGetSurveyAction(action) {
            this.signalRSocket.invoke(
                "RequireGetSurvey",
                this.roomId,
                this.userId,
                action.user.id,
                action.title
            );
        },
        loadAction(actualAction) {
            switch (actualAction) {
                case "text":
                    this.prepareActionComponent = PrepareText;
                    break;
                case "file":
                    this.prepareActionComponent = PrepareFile;
                    break;
                case "photo":
                    this.prepareActionComponent = PreparePhoto;
                    break;
                case "share-document":
                    this.prepareActionComponent = PrepareShareDocument;
                    break;
                case "date":
                    this.prepareActionComponent = PrepareDate;
                    break;
                case "sign":
                    this.prepareActionComponent = PrepareSign;
                    break;
                case "get-survey":
                    this.prepareActionComponent = GetSurvey;
                    break;
                default:
                    this.prepareActionComponent = null;
            }
        },
    },
};
</script>